import { render, staticRenderFns } from "./RecordingChainDrawer.vue?vue&type=template&id=1997fda2&scoped=true"
import script from "./RecordingChainDrawer.vue?vue&type=script&lang=ts"
export * from "./RecordingChainDrawer.vue?vue&type=script&lang=ts"
import style0 from "./RecordingChainDrawer.vue?vue&type=style&index=0&id=1997fda2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1997fda2",
  null
  
)

export default component.exports